export enum FormInputType {
    date = "date",
    datetime = "datetime-local",
    email = "email",
    month = "month",
    number = "number",
    password = "password",
    search = "search",
    tel = "tel",
    text = "text",
    time = "time",
    url = "url",
    week = "week"
}
